<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid ? submit() : ''" ref="form">
                <v-row dense>
                    <v-col cols="auto">
                        <p class="text-meta text-grey-darken-2 mb-0 pt-1">نوع:</p>
                    </v-col>
                    <v-col>
                        <v-radio-group v-model="service.is_product" class="mt-0" inline>
                            <v-radio label="سرویس" :value="false"></v-radio>
                            <v-radio label="محصول" :value="true"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <switch-input v-model="service.status" label="وضعیت دپارتمان"></switch-input>
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان"
                    v-model="service.name"
                ></v-text-field>
                <v-autocomplete
                    :rules="$validation('required')"
                    :items="departments"
                    v-model="service.departments"
                    item-props
                    item-title="name"
                    item-value="id"
                    label="* دپارتمان"
                    no-data-text="موردی پیدا نشد!"
                    clearable
                    multiple
                >
                    <template #prepend-item v-if="departments.length">
                        <toggle-select-all @clicked="$text.toggleSelectAll('service.departments' , 'departments', $data)" :items='service.departments' :all='departments'></toggle-select-all>
                    </template>
                </v-autocomplete>
                <v-textarea
                    :rules="$validation()"
                    no-resize
                    rows="3"
                    label="توضیحات"
                    model-value=""
                    v-model="service.description"
                ></v-textarea>
                <div class="mt-4">
                    <v-btn color="success" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn class="ms-3" variant="text" color="error" @click="$router.push({path: '/settings/services' })" :disabled="loading">بازگشت</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>
<script>
export default {
    title: "ویرایش",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            service: {
                name: null,
                description: null,
                status: true,
                departments: [],
                is_product: true,
            },
            departments: [],
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.$serviceUpdate(this.$route.params.id, this.service).then(
                (res) => {
                    if (res && res.status == "UPDATED") {
                        this.$toast.success(res.message);
                        this.$system.setSystemDefaults(true);
                        this.$system.clearAdminDefaults();
                        this.$auth.fetchUser(true);
                        this.$router.push({path: '/settings/services'})
                    }
                }
            ).finally(()=>{this.loading = false});
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            this.departments = this.$system.departments.filter(x => ![this.$system.customers_department.id].includes(x.id));
            await this.$serviceGet(this.$route.params.id).then((res) => {
                if (res && res.status == "OK") {
                    this.service = res.data;
                    this.is_product = this.service["is_product"] ? "1" : "0";
                    this.departments = this.departments.map(x => { return {...x, disabled: this.service.disabled_departments.includes(x.id)}})
                    this.service.departments = this.service.departments.map(x => x.id);
                    delete this.service.disabled_departments;
                }
            });
            this.$loading.finish();
        });
    },
};
</script>
